var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardPanel',{staticClass:"tips-panel"},[_c('OperationResultTips',{staticClass:"result-tips",attrs:{"type":"validate","tips-title":"Oops! Something went wrong.","tips-content":"Please contact the admin for more information."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }